module.exports = __webpack_public_path__ + "img/hrapp-logo.6dde8f74.png";